import React, { FC, ReactElement } from 'react';

import { trans } from '../../../helpers/trans';
import { FormOption } from '../../../types';
import { CheckboxList } from '../..';

interface CandidateTypesFilterProps {
    hasLLO?: boolean;
    label: string;
    hideLabel?: boolean;
    value: string[];
    candidateTypes: FormOption[];
    tabIndex?: number;
    onChange: (value: string[]) => void;
    className?: string;
}

const CandidateTypesFilter: FC<CandidateTypesFilterProps> = ({
    hasLLO,
    label,
    hideLabel,
    value,
    candidateTypes,
    tabIndex,
    onChange,
    className = '',
}): ReactElement => {
    const options = hasLLO ? [
        ...candidateTypes,
        { label: trans('basic.candidateType.llo'), value: 'llo_candidate' },
    ] : candidateTypes;

    return (
        <div className={`candidate-types-filter ${className}`}>
            <CheckboxList
                label={label}
                hideLabel={hideLabel}
                name="candidate-types"
                options={options}
                value={value}
                tabIndex={tabIndex}
                onChange={onChange}
            />
        </div>
    );
};

export default CandidateTypesFilter;
